import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
  standalone: false,
})
export class FormControlComponent {
  @Input() size: 'small' | 'medium' | 'large' | 'full' = 'full';
  @Input() margin: 'small' | 'full' = 'full';
  @Input() columnLayout = false;
}
